//GLOBAL - components from npm
import React, { useState, useRef, useEffect } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { Tooltippy } from "../../../actions/Tippy";
import Moment from "moment";

// UTILS

//STYLES
import "./bar-chart.css";

//COMPONENTS
import { withTheme } from "@emotion/react";

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...
import { ReactComponent as InfoCircle } from "../../../build/images/info-circle.svg";

var TimeFormat = require("hh-mm-ss");

export default function BarChart({
  data,
  keys = ["value"],
  botAxis = false,
  showLabel = false,
  darkMode = false,
  layout = "vertical",
  onClick = () => null,
  typeValue = "",
}) {
  const theme = {
    axis: {
      domain: {
        line: {
          stroke: darkMode ? "#ffffff" : "rgba(0, 0, 0, 0.1)",
          strokeWidth: 0,
        },
      },
      ticks: {
        text: {
          fontFamily: "Inter",
          fontSize: 12,
          fill: "#757575",
          fontStyle: "normal",
          lineHeight: 20,
          width: 75,
          transform: "translate(0, 0)",
        },
        line: {
          strokeWidth: 0,
        },
      },
    },
    grid: {
      line: {
        stroke: darkMode ? "#ffffff" : "rgba(0, 0, 0, 0.1)",
        strokeWidth: 1,
      },
    },
  };

  const BAR_MAX_WIDTH = 160;

  const CustomBarComponent = ({ bar: { x, y, width, height, color } }) => {
    const w = width > BAR_MAX_WIDTH ? BAR_MAX_WIDTH : width;

    return (
      <rect
        // x={x + width / 2 - w / 2}
        x={x + 5}
        y={y}
        width={width}
        height={height}
        rx={Math.min(width, height) / 2}
        fill={color}
      />
    );
  };

  const BarComponent = ({ bars }) => {
    const lengthMax = data.length > 15 ? 6 : 5;
    let widthTotal = 0;

    for (const bar of bars) {
      if (bar.width > widthTotal) {
        widthTotal = bar.width;
      }
    }
    return (
      <g>
        {bars.map(({ width, height, y, X, data: { data } }) => {
          // only show this custom outer label on bars that are too small
          // data.label.length > 7 && width < labelSkipWidth

          const label = data.value !== undefined ? data.value : 0;
          let exhib = "";
          let contentTippy = "";

          const dias = Math.floor(parseInt(label) / (3600 * 24)).toString();
          const horas = Math.floor(
            (parseInt(label) % (3600 * 24)) / 3600
          ).toString();
          const minutos = Math.floor((parseInt(label) % 3600) / 60).toString();
          const segundos = Math.floor(parseInt(label) % 60).toString();

          const timeDays = `${dias} dia${dias > 1 ? "s" : ""}`;

          const timeComplete = `${dias} dia${
            dias > 1 ? "s" : ""
          }, ${horas.padStart(2, "0")}:${minutos.padStart(
            2,
            "0"
          )}:${segundos.padStart(2, "0")}`;

          const time = `${horas.padStart(2, "0")}:${minutos.padStart(
            2,
            "0"
          )}:${segundos.padStart(2, "0")}`;

          if (
            typeValue === "duration" ||
            typeValue === "tmpausa" ||
            typeValue === "tmentrada" ||
            typeValue === "tmsaida"
          ) {
            // exhib = Moment.utc(1000 * parseInt(label)).format("dddd, h:mm:ss");
            exhib = dias > 0 ? timeDays : time;
            contentTippy = dias > 0 ? timeComplete : time;
            // exhib = TimeFormat.fromS(parseInt(label), "hh:mm:ss");
          } else if (typeValue === "gdaagent") {
            exhib = `${
              parseFloat(label) > 0 ? parseFloat(label).toFixed(2) : 0
            }%`;
          } else {
            exhib = label;
          }

          return (
            <Tooltippy key={data.id} content={contentTippy || exhib}>
              <text
                transform={`translate(${widthTotal + 10}, ${y + height / 2})`}
                fill={"#000"}
                text-anchor="right"
                dominant-baseline="central"
                className="text-style"
              >
                {exhib}
              </text>
            </Tooltippy>
          );
        })}
      </g>
    );
  };

  return (
    <div style={{ height: "99%" }}>
      <ResponsiveBar
        height={data.length < 15 ? 350 : data.length * 20}
        data={data}
        onClick={onClick}
        enableLabel={showLabel}
        theme={theme}
        keys={keys}
        margin={{
          top: 0,
          right: 70,
          bottom: 0,
          left: 80,
        }}
        padding={0.4}
        borderRadius={5}
        layout={layout}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={({ id, data }) => String(data[`${id}Color`])}
        // defs={[
        //   {
        //     id: "dots",
        //     type: "patternDots",
        //     background: "inherit",
        //     color: "#38bcb2",
        //     size: 4,
        //     padding: 1,
        //     stagger: true,
        //   },

        //   {
        //     id: "lines-pattern",
        //     type: "patternLines",
        //     spacing: 13,
        //     rotation: 0,
        //     lineWidth: 2,
        //     background: "#ffffff",
        //     color: "#000000",
        //   },
        // ]}
        borderColor={{
          from: "color",
          modifiers: [["darker", 1.6]],
        }}
        enableGridX={false}
        enableGridY={layout === "horizontal" ? false : true}
        axisTop={null}
        axisRight={null}
        axisBottom={null}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "",
          legendPosition: "middle",
          legendOffset: -40,
          format: (v) => {
            return v.length > 10 ? (
              <Tooltippy content={v}>
                <tspan>{v.substring(0, 10) + "..."}</tspan>
              </Tooltippy>
            ) : (
              v
            );
          },
        }}
        labelSkipWidth={100}
        labelSkipHeight={12}
        labelTextColor={"white"}
        role="application"
        ariaLabel="Nivo bar chart demo"
        // tooltip={({ id, value, color, data }) => (
        //   <div className="tooltip-text">
        //     <div
        //       style={{ width: 12, height: 12, backgroundColor: color }}
        //     ></div>
        //     <h6 color={"white"}>
        //       {data.label
        //         ? `${
        //             data.label.charAt(0).toUpperCase() + data.label.substring(1)
        //           } - ${value} casos`
        //         : `${
        //             id.charAt(0).toUpperCase() + id.substring(1)
        //           } - ${value} casos`}
        //     </h6>
        //   </div>
        // )}
        barComponent={CustomBarComponent}
        layers={[
          "grid",
          "axes",
          "bars",
          "markers",
          "legends",
          "annotations",
          layout !== "vertical" ? BarComponent : null,
        ]}
        legends={[]}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
      />
    </div>
  );
}
